export default class VodPackageService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/vodPackages', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/vodPackages/' + id, params)
	}

	getSimpleList(params) {
		return this.apiService.callGet('me/vodPackages/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/VodPackageService.js